import { render, staticRenderFns } from "./viewPHPCustom.vue?vue&type=template&id=5c1338d4&scoped=true&"
import script from "./viewPHPCustom.vue?vue&type=script&lang=js&"
export * from "./viewPHPCustom.vue?vue&type=script&lang=js&"
import style0 from "./viewPHPCustom.vue?vue&type=style&index=0&id=5c1338d4&scoped=true&lang=css&"
import style1 from "./viewPHPCustom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1338d4",
  null
  
)

export default component.exports